<div class="monster" (click)="setRandomColor()" [ngClass]="isCollapsed ? 'is-collapsed' : ''">
    <span class="body" #bobby></span> <span class="eyes" (click)="rainbowMode()"></span>
</div>
